import React, { useState } from "react";
import { Card, Tab, Nav } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useLocation } from "react-router-dom";
import PremiumUserTable from "./PremiumUsersTable";

export default function PremiumUser() {
  const location = useLocation();

  return (
    <div>
      <Card>
        <Card.Body>
          <div className="default-tab">
            <PremiumUserTable />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
